import { useConnectModal } from '@rainbow-modules/hooks';
import FormModal from 'components/FormModal';
import isCallback from 'helpers/isCallback';
import { BaseFormProps } from './types';
import Fields from './fields';

const mapFormValues = (values: Record<string, unknown>) => ({
    ...values,
    importance: Number(values.importance),
});

const EditMemoryForm = ({ modalId }: BaseFormProps) => {
    const {
        onSubmit, ...connectedModalProps
    } = useConnectModal(modalId);

    const onSubmitMiddleware = (formValues: Record<string, unknown>) => {
        if (isCallback(onSubmit)) onSubmit(mapFormValues(formValues));
    };

    return (
        <FormModal
            {...connectedModalProps}
            borderRadius="semi-square"
            size="medium"
            fields={Fields}
            onSubmit={onSubmitMiddleware}
        />
    );
};

export default EditMemoryForm;
